<template>
  <div class="w-100">
    <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
      <b-col cols="12" class="mb-3">
        <PageTitle :title="$route.name == 'lojista-app-cupom-cashback' ? 'Cupom de cashback' : 'Cupom de desconto'" />
      </b-col>
    </b-row>
  
    <b-col cols="12" class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">Meus cupons</h3>
      <b-button 
        variant="success"
        pill
        @click="$refs.modalCoupon.toggleOpen({data: []})"
      >
        <i class="fas fa-plus-circle mr-2"></i>
        Criar cupom
      </b-button>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :fields="tableCoupon.headers"
        :items="tableCoupon.records"
      >
      
      <template #cell(cupom)="data">
        {{ data.item.coupon }}
      </template>

      <template #cell(type)="data">
        <span v-if="data.item.type == CouponType.PERCENTAGE">
          Em porcentagem
        </span>
        <span v-else>Em reais</span>
      </template>

      <template #cell(value)="data">
        <span v-if="data.item.type == CouponType.MONEY">
          R$ {{ formatMoney(data.item.value) }}
        </span>
        <span v-else>
          {{ data.item.value }}%
        </span>
      </template>

      <template #cell(createdAt)="data">
        {{ formatDate(data.item.created_at) }}
      </template>
      
      <template #cell(expiredAt)="data">
        <span v-if="data.item.expiration_data">{{ formatDate(data.item.expiration_data) }}</span>
        <span v-else>Sem validade</span>
      </template>

      <template #cell(actions)="data">
        <b-button
          @click="$refs.modalCoupon.toggleOpen({data: data.item})"
          class="mr-2"
          variant="primary"
          size="sm"
          title="Editar cupom"
        >
          <i class="fas fa-edit"></i>
        </b-button>
        <b-button
          @click="$refs.modalDeleteCoupon.toggleOpen({data: data.item})"
          variant="danger"
          size="sm"
          title="Excluir cupom"
        >
          <i class="fas fa-trash"></i>
        </b-button>

        <b-button
          @click="$refs.modalViewCoupon.toggleOpen({data: data.item})"
          variant="warning"
          size="sm"
          title="Analisar cupom"
          class="ml-2"
        >
          <i class="fas fa-eye"></i>
        </b-button>
      </template>
      </b-table>
    </b-col>
    
    <ModalCoupon
      ref="modalCoupon" 
      @createCupom="newCoupon($event)"
      @updateCupom="editCoupon($event)"
    />

    <ModalDeleteCoupon
      ref="modalDeleteCoupon" 
      @destroyCoupon="destroyCoupon($event)"
    />

    <ModalViewCoupon
      ref="modalViewCoupon"
    />

  </div>
</template>

<script>
import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';

import { mapActions, mapState } from 'vuex';
import ModalCoupon from './ModalCoupon.vue';
import ModalDeleteCoupon from './ModalDeleteCoupon.vue';
import ModalViewCoupon from './ModalViewCoupon.vue';
import CouponType from '@/enums/CouponType';


export default {
  name: 'CouponDiscount',
  mixins: [makeToast],
 
  components: {
    PageTitle,
    ModalCoupon,
    ModalDeleteCoupon,
    ModalViewCoupon
  },
  
  data() {
    return {
      CouponType,
      tableCoupon: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'cupomId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'cupom',
            label: 'Cupom',
            sortable: false,
          },
          {
            key: 'type',
            label: 'Tipo',
            sortable: false,
          },
          {
            key: 'value',
            label: 'Valor',
            sortable: false,
          },
          {
            key: 'createdAt',
            label: 'Criado em',
            sortable: false,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
          },
          {
            key: 'expiredAt',
            label: 'Válido até',
            sortable: false,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  watch: {
    '$route.name': function () {
      if (['lojista-app-cupom-cashback', 'lojista-app-cupom-desconto'].includes(this.$route.name)) {
        this.getCoupons();
      }
    },
  },

  mounted() {
    this.getCoupons();
  },

  methods: {
    ...mapActions('shopkeeper', [
      'createCoupon', 
      'updateCoupon', 
      'getCoupon', 
      'deleteCoupon', 
    ]),

    newCoupon(data) {
      data.construp_user_id = this.dadosUsuario.id;
      data.typeCounpon = this.$route.name == 'lojista-app-cupom-cashback' ? 'cashback' : 'discont'

      this.createCoupon(data) 
        .then((response) => {
          this.tableCoupon.records = response.data.data || [];
          this.getCoupons();
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao criar um novo cupom', 'danger');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getCoupons() {
      const data = {
        userId: this.dadosUsuario.id,
        type: this.$route.name == 'lojista-app-cupom-cashback' ? 'cashback' : 'discont'
      }

      this.$store.dispatch('startLoader');
      this.getCoupon(data) 
        .then((response) => {
          this.tableCoupon.records = response.data.data || [];
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os cupons', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },

    editCoupon(data) {
      this.$store.dispatch('startLoader');
      this.updateCoupon(data) 
        .then(() => {
          this.getCoupons();
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao atualizar o cupom', 'danger');
          this.$store.dispatch('endLoader');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    destroyCoupon(id) {
      this.$store.dispatch('startLoader');
      this.deleteCoupon(id) 
        .then(() => {
          this.getCoupons();
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao deletar o cupom', 'danger');
          this.$store.dispatch('endLoader');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatMoney(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    }
  }
}

</script>